import { useEffect } from 'react';
import { addEventListener } from '../utils/dom';
import { debounce } from '../utils/function';
const resizeHandlers = new Set();
const handleResize = (event) => resizeHandlers.forEach(handler => handler(event));
export default function useResize({ handler, debounce: time = 0, enabled = true }) {
    useEffect(() => {
        const prepared = time ? debounce(handler, time) : handler;
        let off = () => { };
        if (enabled) {
            resizeHandlers.add(prepared);
        }
        if (resizeHandlers.size === 1) {
            off = addEventListener('resize', handleResize);
        }
        return () => {
            resizeHandlers.delete(prepared);
            if (resizeHandlers.size === 0) {
                off();
            }
        };
    }, [handler, time, enabled]);
}
//# sourceMappingURL=use-resize.js.map